import React, { useState, useEffect } from "react";
import { Notification } from "../common/Notification";
import { useForm } from "react-hook-form";
import { PATTERNS } from "../../util/patterns";
import { useSelector, useDispatch } from "react-redux";
import { ApplicationState } from "../../store";
import * as service from "../../store/service";
import * as common from "../../util/common";
import * as LoginActions from "../../store/loginService/actions";
import { NavLink } from "react-router-dom";
import { DialogComponent } from "./../common/DialogComponent";
import IDFProtectionPlanBillingInfo from "./protectionPlan/IDFProtectionPlanBillingInfo";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";
import * as LoginTypes from "../../store/loginService/types";
import * as ConfigurationActions from "../../store/configurationService/actions";
import * as BannerMessageActions from "../../store/bannerMessage/actions";
import * as PackageServicesActions from "../../store/packageUpgradeService/actions";
import { useTranslation } from 'react-i18next';
import { isIDFPartnerUser } from "../../util/partner";

const IDFFamilyServiceDialog: React.FunctionComponent<{ closeDialog(): void; history: any; dialogId: string }> = (props) => {
    const isServiceActive = (serviceDisplayName: string, state: ApplicationState) => {
        const services =
            state.loggedInUser && state.loggedInUser.userServiceDetails && state.loggedInUser.userServiceDetails.userServices
                ? state.loggedInUser && state.loggedInUser.userServiceDetails.userServices
                : [];
        const selectedService = services.find((service) => service.displayName === serviceDisplayName);
        if (selectedService && selectedService.active) {
            return true;
        }
        return false;
    };
    const setChildSubCustomerIDToCompleteAccoutSetup = (subCustomerID: string) =>
        dispatch(LoginActions.actionCreators.setChildSubCustomerIDToCompleteAccountSetup(subCustomerID));
    const [isTermsNadConditionCHecked, setIsTermsNadConditionCHecked] = useState(false);
    const date = new Date();
    const year = parseInt(date.getFullYear().toString());
    let yearList: number[] = [];
    for (let i = year; i <= year + 10; i++) {
        yearList.push(i);
    }

    const isIDFFamilyServiceActive = useSelector((state: ApplicationState) => isServiceActive("Family", state));
    const isIDFFamilyChildActive = useSelector((state: ApplicationState) => isServiceActive("Family 3.0 Child", state));
    const isIDFFamilySpouseActive = useSelector((state: ApplicationState) => isServiceActive("Family 3.0 Spouse", state));
    const isIDFFamilyAdultActive = useSelector((state: ApplicationState) =>  isServiceActive("Family 3.0 Adult", state) || isServiceActive("Family 3.0 Young Adult", state));
    const familyOffer = useSelector((state: ApplicationState) => (state.myAccountServiceState ? state.myAccountServiceState.familtOffer : null));
    const maximumChildAge = 18;

    const minimumMemberAge = 18;

    const familyMembers = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.familyMembers ? state.loggedInUser.familyMembers : []
    );
    const spouseAccounts = familyMembers.filter(
        (familyAccount) => familyAccount.accountType && familyAccount.accountType.includes("spouse")
    );
    const adultAccounts = familyMembers.filter(
        (familyAccount) => familyAccount.accountType && familyAccount.accountType.includes("adult")
    );

    const serviceList = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userServiceDetails && state.loggedInUser.userServiceDetails.userServices ? state.loggedInUser.userServiceDetails.userServices : []
    );
    const adult30Service = serviceList.find( (serviceList) => serviceList.displayName==="Family 3.0 Adult" );
    const youngAdult30Service = serviceList.find( (serviceList) => serviceList.displayName==="Family 3.0 Young Adult" );

    // The max allowable Adult 3.0 members that can be added is passed in the productDescription
    // field to avoid the need for adding a new field to the response from the IDF v4 services GET
    // endpoint. The productDescription field was unused for the family 3.0 services, so it made
    // sense to use it for this purpose rather than adding a new, special-purpose field in the
    // response from the IDF v4 API services GET endpoint just for this.
    const maxAdult30Accounts = adult30Service && adult30Service.productDescription
                             ? adult30Service.productDescription
                             : ( youngAdult30Service && youngAdult30Service.productDescription
                               ? youngAdult30Service.productDescription
                               : 0
                               )
                               ;

    const [isLoading, setisLoading] = useState(false);
    const [paymentError, setPaymentError] = useState(false);
    const dispatch = useDispatch();
    const updateFamilyMember = (familyMembers: any) => dispatch(LoginActions.actionCreators.updateFamilyMember(familyMembers));
    const getFamilyMembers = () => dispatch(LoginActions.actionCreators.getFamilyMembers(true));
    const [familyAccount, setFamilyAccount] = useState({ firstName: "", lastName: "", dateOfBirth: "", relationship: "", email: "" });
    const [childAgeError, setChildAgeError] = useState(false);
    const [memberAgeError, setMemberAgeError] = useState(false);
    const [youngAdultMemberAgeError, setYoungAdultMemberAgeError] = useState(false);
    const [negativeAgeError, setNegativeError] = useState(false);
    const [familyMember, setFamilyMember] = useState<any>([]);
    const [step, setStep] = useState(1);
    const [showChildwatchContent, setShowChildwatchContent] = useState(false);
    const [activeChildCount, setActiveChildCount] = useState(0);
    const { t: tLang } = useTranslation();
    const termsOfUseLegalDocumentLabel: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.termsOfUseLegalDocumentLabel
            ? state.configurationState.configuration.partnerConfig.termsOfUseLegalDocumentLabel === "Terms of Use"
                ? tLang("pageFooter.termsOfUse")
                : state.configurationState.configuration.partnerConfig.termsOfUseLegalDocumentLabel
            : tLang("pageFooter.termsOfUse")
    );
    const privacyPolicyLegalDocumentLabel: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.privacyPolicyLegalDocumentLabel
            ? state.configurationState.configuration.partnerConfig.privacyPolicyLegalDocumentLabel === "Privacy Notice"
                ? tLang("pageFooter.privacyNotice")
                : state.configurationState.configuration.partnerConfig.privacyPolicyLegalDocumentLabel
            : tLang("pageFooter.privacyPolicy")
    );
    const isPartnerIdIsGoezshield = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 36
                ? true
                : false
            : false
    );
    const termsOfUseLegalDocumentLink: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.termsOfUseLegalDocumentLink
            ? state.configurationState.configuration.partnerConfig.termsOfUseLegalDocumentLink
            : ""
    );
    const privacyPolicyLegalDocumentLink: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.privacyPolicyLegalDocumentLink
            ? state.configurationState.configuration.partnerConfig.privacyPolicyLegalDocumentLink
            : ""
    );
    const csidUserStatus = useSelector((state: ApplicationState) =>
        state.csidUserStatusState && state.csidUserStatusState.csidUserStatus ? state.csidUserStatusState.csidUserStatus : null
    );
    const isIDFPartner = useSelector((state: ApplicationState) =>
        state.configurationState &&
            state.configurationState.configuration.partnerConfig.partnerId &&
            state.configurationState.configuration.partnerConfig.isIdfPartner
            ? !isIDFPartnerUser(state.configurationState.configuration.partnerConfig.partnerId)
            : false
    );
    const userCountry = useSelector((state: ApplicationState) =>
        state.myAccountServiceState?._unifiedAccountInfo?.country
    );
    const countryRequiresAuthentication = useSelector((state: ApplicationState) => {
        return ['US', 'CA'].includes(userCountry || '');
    });
    const switchFamilyAccount = (activeAccount: LoginTypes.IUserFamilyAccountInfo, familyMembers: LoginTypes.IUserFamilyAccountInfo[]) =>
        dispatch(LoginActions.actionCreators.switchFamilyAccount(activeAccount, props.history, familyMembers));
    const setRedirectToDashboard = (forceUpdate: boolean) => dispatch(ConfigurationActions.actionCreators.setRedirectToDashboard(forceUpdate));
    const packageServicesAction = () => dispatch(PackageServicesActions.actionCreators.requestPackageData());
    const isAuthenticated = csidUserStatus?.["auth-status"]?.toLocaleLowerCase() === "authenticated";
    const requestBannerMessage = () => dispatch(BannerMessageActions.actionCreators.getBannerAlertMessage(true));

    const { register, errors, handleSubmit } = useForm({
        mode: "onBlur",
        reValidateMode: "onChange",
    });

    const [showBillingInfoDialog, setShowBillingInfoDialog] = useState(false);
    const handleBillingCloseDialog = (value: string): any => {
        if (value === "show") {
            setShowBillingInfoDialog(true);
        } else if (value === "cancel") {
            document.body.classList.remove("no_scroll");
            setShowBillingInfoDialog(false);
        } else if (value === "close") {
            document.body.classList.remove("no_scroll");
            setShowBillingInfoDialog(false);
            loadPaymentInfoData();
        }
    };
    const showBillingInformation = (event: any) => {
        handleBillingCloseDialog("show");
    };

    const [creditCard, setCreditCard] = useState({
        cardNumber: "",
        nameOnCard: "",
        billingZip: "",
        cardType: "",
        countryId: 0,
        expDateMo: "",
        expDateYr: "",
        expirationDate: "",
        securityCode: "",
    });

    const loadPaymentInfoData = () => {
        service.GetPaymentDetail().then((data) => {
            setCreditCard(data.creditCard);
        });
    };

    const [childProduct, setChildProduct] = useState({
        id: "",
        name: "",
        code: "",
        annualCost: "",
        monthlyCost: "",
        upgradeOrder: "",
        upgradeCost: "",
        totalOfferCost: "",
        billingCycle: "",
        prorateCost: "",
    });

    const [adultProduct, setAdultProduct] = useState({
        id: "",
        name: "",
        code: "",
        annualCost: "",
        monthlyCost: "",
        upgradeOrder: "",
        upgradeCost: "",
        totalOfferCost: "",
        billingCycle: "",
        prorateCost: "",
    });

    useEffect(() => {
        document.querySelector<any>(`[aria-labelledby=${props.dialogId}-title]`)!.classList.add("width-lg");
        loadPaymentInfoData();
        setisLoading(true);
        service
            .getUserAddPrice()
            .then((data) => {
                setisLoading(false);
                if (!data.hasError) {
                    if (data["adultProduct"]) {
                        setAdultProduct(data["adultProduct"]);
                    }
                    if (data["childProduct"]) {
                        setChildProduct(data["childProduct"]);
                    }
                }
            })
            .catch(() => {
                setisLoading(false);
            });
        let childCount = 0
        familyMembers?.forEach(el => {
            if (el.accountType?.toLowerCase() === 'add child') {
                childCount += 1;
            }
        });
        setActiveChildCount(childCount);
    }, []);

    const closeDialog = () => {
        document.body.classList.remove("no_scroll");
        props.closeDialog();
    };

    const refreshFamilyMembersInformation = () => {
        setisLoading(false);
        getFamilyMembers();
        closeDialog();
    };

    let birthDateFieldPressedKey: number;
    const updatBirthDatePressedKey = (e: any) => {
        birthDateFieldPressedKey = e.keyCode;
    };

    function onChangeHandler(event: any) {
        const name = event.currentTarget.name;
        if (event.currentTarget.tagName === 'SELECT') {
            if (event.currentTarget.value === 'add child' || event.currentTarget.value === 'family plan child') {
                setShowChildwatchContent(true);
            } else {
                setShowChildwatchContent(false);
            }
        }
        setFamilyAccount({ ...familyAccount, [name as string]: event.currentTarget.value });
        if (event.currentTarget.name === "dateOfBirth") {
            if ((event.target.value.length == 2 || event.target.value.length == 5) && birthDateFieldPressedKey != 8 && birthDateFieldPressedKey !== 46) {
                event.target.value = event.target.value + "/";
            }
            checkMemberAge(event.currentTarget.value);
        } else if (event.currentTarget.name === "relationship") {
            checkMemberAge(familyAccount.dateOfBirth, event.currentTarget.value);
        } else {
            checkMemberAge(familyAccount.dateOfBirth);
        }
    }

    const switchUserAccount = (userData: any) => {
        requestAccountSwitch(userData["subcustomerId"], userData);
    };

    const requestAccountSwitch = (subcustomerID: string, accountToSwitch: any) => {
        const requestBody = { SubcustomerId: subcustomerID };
        service.switchFamilyAccount(requestBody).then((data) => {
            if (!data["hasError"] && data["familyMembers"]) {
                if (accountToSwitch) {
                    switchFamilyAccount(accountToSwitch, data["familyMembers"]);

                    const path = window.location.pathname;
                    if (path.toLowerCase().endsWith("dashboard")) {
                        setRedirectToDashboard(true);
                        props.history.push("/switch-account");
                    }

                    packageServicesAction();
                    requestBannerMessage();
                }
            }
        });
    };

    const postSumbitPrecess = (data: any) => {
        if (!data["has-error"]) {
            Notification({
                type: "success",
                title: "Add Family Member",
                message: "Family member successfully added.",
                duration: 5,
            });
            if (familyAccount.relationship.includes("child")) {
                let subcustomerID = "";
                if (data["family-add-members"] && data["family-add-members"].length > 0 && data["family-add-members"][0]["id-sub-customer"]) {
                    subcustomerID = data["family-add-members"][0]["id-sub-customer"];
                }
                if (subcustomerID) {
                    service
                        .getUserFamily()
                        .then((data) => {
                            if (!data["hasError"] && data["familyMembers"]) {
                                updateFamilyMember(data["familyMembers"]);
                                setChildSubCustomerIDToCompleteAccoutSetup(subcustomerID);
                                const userData: any = data["familyMembers"].find((x: any) => x.subcustomerId === subcustomerID);

                                switchUserAccount(userData);
                            }
                            setisLoading(false);
                        })
                        .catch(() => {
                            setisLoading(false);
                            refreshFamilyMembersInformation();
                        });
                } else {
                    refreshFamilyMembersInformation();
                }
            } else {
                refreshFamilyMembersInformation();
            }
        } else {
            Notification({
                type: "error",
                title: "Add Family Member Error",
                message: "Could not add family member. Please Try again later.",
            });
            setisLoading(false);
        }
    };

    const saveFamilyMember = () => {
        const requestBody = {
            "use-card-on-file": true,
            "family-members": [
                {
                    "account-type": familyAccount.relationship,
                    "first-name": familyAccount.firstName,
                    "last-name": familyAccount.lastName,
                    email: familyAccount.email,
                    "date-of-birth": familyAccount.dateOfBirth,
                },
            ],
            "country-id": "24",
        };

        if (!creditCard?.cardNumber) {
            setPaymentError(true);
        } else {
            setisLoading(true);

            service
                .addFamilyMember(requestBody)
                .then((data) => {
                    if (familyAccount.relationship.includes("child")) {
                        service.getUserFamily().then((userFamilyData: any) => {
                            updateFamilyMember(userFamilyData["familyMembers"]);
                            const newUserData: any = userFamilyData["familyMembers"].find(
                                (x: any) => x.subcustomerId === data["family-add-members"][0]["id-sub-customer"]
                            );
                            if (newUserData.userId) {
                                const completeChildAccountPayload = {
                                    "check-ssn": "",
                                    childAccountID: newUserData.userId,
                                    "date-of-birth": familyAccount.dateOfBirth,
                                    "family-members": [],
                                    "first-name": familyAccount.firstName,
                                    "last-name": familyAccount.lastName,
                                    "middle-initial": "",
                                    "monitor-primary-email": true,
                                    monitors: [],
                                    ssn: "",
                                    "tos-check": true,
                                };
                                service
                                    .completeAccountSetup(completeChildAccountPayload)
                                    .then((res) => {
                                        postSumbitPrecess(data);
                                    })
                                    .catch((err: any) => {});
                            } else {
                                Notification({
                                    type: "error",
                                    title: "Add Family Member Error",
                                    message: "Child Id not found.",
                                });
                            }
                        });
                    } else {
                        postSumbitPrecess(data);
                    }
                })
                .catch(() => {
                    refreshFamilyMembersInformation();
                    Notification({
                        type: "error",
                        title: "Add Family Member Error",
                        message: "Could not add family member. Please Try again later.",
                    });
                    setisLoading(false);
                });
        }
    };

    const addFamilyMember = () => {
        if (isIDFFamilyServiceActive) {
            if (step === 1 && !childAgeError && !negativeAgeError && !memberAgeError) {
                setStep(2);
                const familMemberDetails = {
                    "account-type": familyAccount.relationship,
                    "first-name": familyAccount.firstName,
                    "last-name": familyAccount.lastName,
                    email: familyAccount.email,
                    "date-of-birth": familyAccount.dateOfBirth,
                };
                let familyMemeberCpy = familyMember;
                familyMemeberCpy.push(familMemberDetails);
                setFamilyMember(familyMemeberCpy);
            } else if (step === 2) {
                saveFamilyMember();
            }
        } else {
            const requestBody = {
                "check-if-valid": false,
                "family-members": [
                    {
                        "account-type": familyAccount.relationship,
                        "first-name": familyAccount.firstName,
                        "last-name": familyAccount.lastName,
                        email: familyAccount.email,
                        "date-of-birth": familyAccount.dateOfBirth,
                    },
                ],
            };
            if (!childAgeError && !negativeAgeError && !memberAgeError && !youngAdultMemberAgeError) {
                setisLoading(true);

                service
                    .addFamilyPlanMember(requestBody)
                    .then((data) => {
                        if (familyAccount.relationship.includes("child")) {
                            service.getUserFamily().then((userFamilyData: any) => {
                                updateFamilyMember(userFamilyData["familyMembers"]);
                                const newUserData: any = userFamilyData["familyMembers"].find(
                                    (x: any) => x.subcustomerId === data["family-add-members"][0]["id-sub-customer"]
                                );
                                if (newUserData.userId) {
                                    const completeChildAccountPayload = {
                                        "check-ssn": "",
                                        childAccountID: newUserData.userId,
                                        "date-of-birth": familyAccount.dateOfBirth,
                                        "family-members": [],
                                        "first-name": familyAccount.firstName,
                                        "last-name": familyAccount.lastName,
                                        "middle-initial": "",
                                        "monitor-primary-email": true,
                                        monitors: [],
                                        ssn: "",
                                        "tos-check": true,
                                    };
                                    service
                                        .completeAccountSetup(completeChildAccountPayload)
                                        .then((res) => {
                                            postSumbitPrecess(data);
                                        })
                                        .catch((err: any) => {});
                                } else {
                                    Notification({
                                        type: "error",
                                        title: "Add Family Member Error",
                                        message: "Child Id not found.",
                                    });
                                }
                            });
                        } else {
                            postSumbitPrecess(data);
                        }
                    })
                    .catch(() => {
                        refreshFamilyMembersInformation();
                        Notification({
                            type: "error",
                            title: "Add Family Member Error",
                            message: "Could not add family member. Please Try again later.",
                        });
                        setisLoading(false);
                    });
            }
        }
    };

    const checkMemberAge = (date: string, relation?: string) => {
        const relationStatus = relation ? relation : familyAccount.relationship;

        try {
            const accountDOBinDateFormate = new Date(date);
            const age = common.calculate_age(accountDOBinDateFormate);
            const todaysDate = new Date();
            if (relationStatus.includes("child")) {
                setMemberAgeError(false);
                if (age >= maximumChildAge) {
                    setChildAgeError(true);
                } else {
                    setChildAgeError(false);
                }
            } else {
                setChildAgeError(false);
                if (age < minimumMemberAge) {
                    setMemberAgeError(true);
                } else {
                    setMemberAgeError(false);
                }
            }

            setYoungAdultMemberAgeError( relationStatus.includes("adult") && undefined!==youngAdult30Service && age > 25);

            if (todaysDate < accountDOBinDateFormate) {
                setNegativeError(true);
            } else {
                setNegativeError(false);
            }
        } catch {
            setChildAgeError(false);
            setNegativeError(false);
        }
    };

    const getRelationshipOption = () => {
        if (isIDFFamilyServiceActive) {
            return (
                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                    <select
                        ref={register({ required: true })}
                        className={errors.relationship ? "status-error inputbox" : "inputbox"}
                        id="edit-suffix"
                        name="relationship"
                        defaultValue={familyAccount.relationship ? familyAccount.relationship : ""}
                        onChange={onChangeHandler}
                        aria-required="true"
                    >
                        <option value="">Select Relationship</option>
                        <option value="add child" disabled={(!isAuthenticated && countryRequiresAuthentication) || activeChildCount>=10}>Child</option>
                        <option value="add spouse">Spouse</option>
                        <option value="add adult">Adult</option>
                    </select>

                    {errors.relationship && errors.relationship.type === "required" && <span className="form-error">Relationship is required.</span>}
                </div>
            );
        } else if (isIDFFamilyChildActive || isIDFFamilySpouseActive || isIDFFamilyAdultActive) {
            return (
                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                    <select
                        ref={register({ required: true })}
                        className={errors.relationship ? "status-error inputbox" : "inputbox"}
                        id="edit-suffix"
                        name="relationship"
                        defaultValue={familyAccount.relationship ? familyAccount.relationship : ""}
                        onChange={onChangeHandler}
                        aria-required="true"
                    >
                        <option value="">Select Relationship</option>
                        {isIDFFamilyChildActive && <option value="family plan child" disabled={(!isAuthenticated && countryRequiresAuthentication) || activeChildCount>=10}>Child</option>}
                        {isIDFFamilySpouseActive && spouseAccounts.length <= 0 && <option value="family plan spouse">Spouse</option>}
                        {isIDFFamilyAdultActive && adultAccounts.length < maxAdult30Accounts && <option value="family plan adult">{undefined!=youngAdult30Service ? "Young " : ""}Adult</option>}
                    </select>

                    {errors.relationship && errors.relationship.type === "required" && <span className="form-error">Relationship is required.</span>}
                </div>
            );
        }
    };

    const getPlanValue = () => {
        if (familyAccount.relationship.includes("add child")) {
            return childProduct.name;
        } else {
            return adultProduct.name;
        }
    };

    const getPreciseValue = (cost: string) => {
        let costInFloat = "0.0";
        if (cost) {
            costInFloat = parseFloat(cost).toFixed(2);
        }
        return costInFloat;
    };

    const getRecurCost = () => {
        if (familyAccount.relationship.includes("add child")) {
            if (childProduct.billingCycle === "yearly") {
                return "$" + getCost() + "/yr";
            } else {
                return "$" + getCost() + "/mo";
            }
        } else {
            if (adultProduct.billingCycle === "yearly") {
                return "$" + getCost() + "/yr";
            } else {
                return "$" + getCost() + "/mo";
            }
        }
    };

    const getCost = () => {
        if (familyAccount.relationship.includes("add child")) {
            if (childProduct.billingCycle === "yearly") {
                return getPreciseValue(childProduct.annualCost);
            } else {
                return getPreciseValue(childProduct.monthlyCost);
            }
        } else {
            if (adultProduct.billingCycle === "yearly") {
                return getPreciseValue(adultProduct.annualCost);
            } else {
                return getPreciseValue(adultProduct.monthlyCost);
            }
        }
    };

    const getBillingCycle = () => {
        if (familyAccount.relationship.includes("add child")) {
            if (childProduct.billingCycle === "yearly") {
                return "year";
            } else {
                return "month";
            }
        } else {
            if (adultProduct.billingCycle === "yearly") {
                return "year";
            } else {
                return "month";
            }
        }
    };

    const openTermsOfUsePage = () => {
        const base_url = decodeURIComponent(encodeURIComponent(window.location.origin)) + "/app";
        if (termsOfUseLegalDocumentLink) {
            const urlToOpen = termsOfUseLegalDocumentLink.startsWith("/") ? base_url + termsOfUseLegalDocumentLink : termsOfUseLegalDocumentLink;
            return urlToOpen;
        }
        return base_url + "/terms";
    };

    const openPrivacyPolicyPage = () => {
        const base_url = decodeURIComponent(encodeURIComponent(window.location.origin)) + "/app";
        if (privacyPolicyLegalDocumentLink) {
            const urlToOpen = privacyPolicyLegalDocumentLink.startsWith("/") ? base_url + privacyPolicyLegalDocumentLink : privacyPolicyLegalDocumentLink;
            return urlToOpen;
        }

        return base_url + "/privacy";
    };

    const getStepView = () => {
        return (
            <React.Fragment>
                <form onSubmit={handleSubmit(addFamilyMember)} id="add-idf-family-form-container">
                    <div className="dialog-body">
                        {step === 1 && (
                            <React.Fragment>
                                {showChildwatchContent && <div>
                                    <p>
                                        {tLang("dashboard.addFamilyMemberDialog.childwatch.attestationStatement2")}
                                    </p>
                                    <h4>{tLang("dashboard.addFamilyMemberDialog.childwatch.attestationFormHeading")}</h4>
                                    <p>{tLang("dashboard.addFamilyMemberDialog.childwatch.attestationFormContent")}&nbsp;
                                        {isPartnerIdIsGoezshield ?
                                            (
                                                <>
                                                    <a
                                                        href={openTermsOfUsePage()}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        onClick={() => {
                                                            window.addToDataLayer({ event: "Terms of Use" });
                                                        }}
                                                    >
                                                        <span className="nav-text">{tLang("PageFooter.label3")}</span>
                                                    </a>&nbsp;
                                                    {tLang("dashboard.addFamilyMemberDialog.childwatch.andText")}&nbsp;
                                                    <a
                                                        href="https://www.sontiq.com/privacy-policy/"
                                                        target="_blank"
                                                        rel="noreferrer">
                                                        <span className="nav-text">{tLang("PageFooter.label4")}</span>
                                                    </a>.
                                                </>
                                            ) :
                                            (
                                                <>
                                                    <a
                                                        href={openTermsOfUsePage()}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        onClick={() => {
                                                            window.addToDataLayer({ event: "Terms of Use" });
                                                        }}
                                                    >
                                                        <span className="nav-text">{termsOfUseLegalDocumentLabel}</span>
                                                    </a>&nbsp;
                                                    {tLang("dashboard.addFamilyMemberDialog.childwatch.andText")}&nbsp;
                                                    <a
                                                        href={openPrivacyPolicyPage()}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        onClick={() => {
                                                            window.addToDataLayer({ event: "Privacy Policy" });
                                                        }}
                                                    >
                                                        <span className="nav-text">{isIDFPartner ? "Privacy Notice" : privacyPolicyLegalDocumentLabel}</span>
                                                    </a>.
                                                </>
                                            )
                                        }
                                    </p>
                                    <h4>
                                        {tLang("dashboard.addFamilyMemberDialog.childwatch.addChildText")}&nbsp;
                                        {activeChildCount + 1}&nbsp;
                                        {tLang("dashboard.addFamilyMemberDialog.childwatch.ofText")}&nbsp;
                                        10
                                    </h4>
                                </div>}
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="edit-suffix">
                                            Relationship{" "}
                                            <span className="required" title="Mandatory">
                                                *
                                            </span>
                                        </label>
                                    </div>
                                    {getRelationshipOption()}
                                </div>

                                <div className={errors["firstName"] ? "form-row row status-error" : "form-row row"}>
                                    <div className="form-row inline row">
                                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                            <label htmlFor="edit-first-name">
                                                First Name{" "}
                                                <span className="required" title="Mandatory">
                                                    *
                                                </span>
                                            </label>
                                        </div>
                                        <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                            <input
                                                type="text"
                                                className={errors.firstName ? "status-error inputbox" : "inputbox"}
                                                id="edit-first-name"
                                                aria-labelledby="edit-first-name"
                                                name="firstName"
                                                defaultValue={familyAccount.firstName ? familyAccount.firstName : ""}
                                                onChange={onChangeHandler}
                                                ref={register({
                                                    required: true,
                                                    pattern: PATTERNS.FIRSTNAME.pattern,
                                                })}
                                                maxLength={30}
                                                aria-required="true"
                                            />
                                            {errors.firstName && errors.firstName.type === "pattern" && (
                                                <span className="form-error">{PATTERNS.FIRSTNAME.message}</span>
                                            )}
                                            {errors.firstName && errors.firstName.type === "required" && (
                                                <span className="form-error">First Name is required.</span>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className={errors["lastName"] ? "form-row row status-error" : "form-row row"}>
                                    <div className="form-row inline row">
                                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                            <label htmlFor="edit-last-name">
                                                Last Name{" "}
                                                <span className="required" title="Mandatory">
                                                    *
                                                </span>
                                            </label>
                                        </div>
                                        <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                            <input
                                                type="text"
                                                className="inputbox"
                                                id="edit-last-name"
                                                aria-labelledby="edit-last-name"
                                                name="lastName"
                                                defaultValue={familyAccount.lastName ? familyAccount.lastName : ""}
                                                onChange={onChangeHandler}
                                                ref={register({
                                                    required: true,
                                                    pattern: PATTERNS.LASTNAME.pattern,
                                                })}
                                                maxLength={30}
                                                aria-required="true"
                                            />
                                            {errors.lastName && errors.lastName.type === "pattern" && (
                                                <span className="form-error">{PATTERNS.LASTNAME.message}</span>
                                            )}

                                            {errors.lastName && errors.lastName.type === "required" && <span className="form-error">Last Name is required.</span>}
                                        </div>
                                    </div>
                                </div>

                                <div className={errors["dateOfBirth"] || childAgeError || negativeAgeError ? "form-row row status-error" : "form-row row"}>
                                    <div className="form-row inline row">
                                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                            <label htmlFor="edit-dateOfBirth">
                                                Date of Birth{" "}
                                                <span className="required" title="Mandatory">
                                                    *
                                                </span>
                                            </label>
                                        </div>
                                        <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                            <input
                                                type="text"
                                                className="inputbox"
                                                id="edit-dateOfBirth"
                                                placeholder="MM/DD/YYYY"
                                                aria-labelledby="edit-dateOfBirth"
                                                name="dateOfBirth"
                                                defaultValue={familyAccount.dateOfBirth ? familyAccount.dateOfBirth : ""}
                                                onKeyDown={updatBirthDatePressedKey}
                                                onChange={onChangeHandler}
                                                ref={register({
                                                    required: true,
                                                    pattern: /^(([0][1-9]|1[012])[/]([0][1-9]|[12][0-9]|3[01])[/](18|19|20|21)?[0-9]{4})*$/,
                                                })}
                                                maxLength={10}
                                                aria-required="true"
                                            />
                                            {errors.dateOfBirth && errors.dateOfBirth.type === "pattern" && (
                                                <span className="form-error">Invalid format. Date of Birth should be MM/DD/YYYY.</span>
                                            )}

                                            {errors.dateOfBirth && errors.dateOfBirth.type === "required" && (
                                                <span className="form-error">Date of Birth is required.</span>
                                            )}

                                            {childAgeError && (
                                                <span className="form-error">
                                                    Children on a {getPlanValue()} plan must be under {maximumChildAge} years old.
                                                </span>
                                            )}

                                            {memberAgeError && (
                                                <span className="form-error">
                                                    {familyAccount.relationship.includes("adult") ? "Member" : "A spouse"} must be 18 years old or older
                                                </span>
                                            )}

                                            {youngAdultMemberAgeError && (
                                                <span className="form-error">
                                                    Young adult members must be less than 26 years old.
                                                </span>
                                            )}

                                            {negativeAgeError && <span className="form-error">Please enter valid date. The given date is future date.</span>}
                                        </div>
                                    </div>
                                </div>

                                {!familyAccount.relationship.includes("child") && (
                                    <div className={errors["email"] ? "form-row row status-error" : "form-row row"}>
                                        <div className="form-row inline row">
                                            <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                                <label htmlFor="edit-email">
                                                    Email{" "}
                                                    <span className="required" title="Mandatory">
                                                        *
                                                    </span>
                                                </label>
                                            </div>
                                            <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                                <input
                                                    type="text"
                                                    className="inputbox"
                                                    id="edit-email"
                                                    aria-labelledby="edit-email"
                                                    name="email"
                                                    defaultValue={familyAccount.email ? familyAccount.email : ""}
                                                    onChange={onChangeHandler}
                                                    ref={register({
                                                        required: true,
                                                        pattern: PATTERNS.EMAIL.pattern,
                                                    })}
                                                    maxLength={PATTERNS.EMAIL.maxLength}
                                                    aria-required="true"
                                                />
                                                {errors.email && errors.email.type === "pattern" && <span className="form-error">{PATTERNS.EMAIL.message}</span>}

                                                {errors.email && errors.email.type === "required" && <span className="form-error">Email is required.</span>}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </React.Fragment>
                        )}
                        {step === 2 && (
                            <React.Fragment>
                                <div className="form-row data-grid has-lines row-height-sm">
                                    <fieldset className="form-row inline">
                                        <div className="row data-row">
                                            <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                <div className="data-label" id="label-payment-info">
                                                    <p>
                                                        <strong>Billing Information</strong>
                                                    </p>
                                                </div>
                                            </div>

                                            <div className={"col-xs-12 col-sm-8 col-no-gutter"}>
                                                <div className="data-value" aria-labelledby="label-payment-info" role="region">
                                                    <div className="row between-xs">
                                                        <div className="col-xs col-no-gutter flex-grow-null">
                                                            {creditCard?.cardNumber ? (
                                                                <p>
                                                                    {creditCard?.nameOnCard && (
                                                                        <span>
                                                                            {creditCard?.nameOnCard}
                                                                            <br />
                                                                        </span>
                                                                    )}
                                                                    <span className="dialog-icon">
                                                                        <em className="las la-credit-card inline-icon"></em> {creditCard?.cardNumber}
                                                                        <br />
                                                                    </span>
                                                                    {creditCard?.expDateMo && creditCard?.expDateYr && (
                                                                        <span>
                                                                            Exp. {[creditCard?.expDateMo, creditCard?.expDateYr].join("/")}
                                                                            <br />
                                                                        </span>
                                                                    )}
                                                                    {creditCard?.billingZip}
                                                                </p>
                                                            ) : (
                                                                <div className="msg-generic msg-small margin-top-xs">
                                                                    <RenderIcons iconName="info-circle" />
                                                                    There is no Payment Profile
                                                                    <br />
                                                                    associated with your account.
                                                                </div>
                                                            )}
                                                        </div>

                                                        <div className="col-xs col-no-gutter flex-grow-null">
                                                            <span
                                                                className="default_link"
                                                                onClick={(e) => {
                                                                    showBillingInformation(e);
                                                                    window.addToDataLayer({ event: "Protection Plan - Billing Info" });
                                                                }}
                                                            >
                                                                <a href="javascript:void(0)" className="default_link">
                                                                    {creditCard?.cardNumber ? "Update" : "Add"}
                                                                </a>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                {!creditCard?.cardNumber && paymentError && (
                                                    <div className="data-value">
                                                        <span className="form-error">Billing information is required</span>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </fieldset>
                                </div>

                                <div className="margin-top-l"></div>
                                <div className="margin-top-l"></div>

                                <div className="box-content data-grid has-lines">
                                    <h3>Billing Summary</h3>
                                    <div role="grid" className="data-grid " id="user-grid" aria-hidden="false">
                                        <div role="row" className="data-row row between-xs between-sm">
                                            <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                                <div className="data-label"> Name</div>
                                            </div>
                                            <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                                <div className="data-label"> Plan</div>
                                            </div>
                                            <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter text-align-right">
                                                <div className="data-label"> Price</div>
                                            </div>
                                        </div>

                                        <div role="row" className="data-row row between-xs between-sm">
                                            <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                                <div className="data-value">
                                                    <em
                                                        className="las la-pen"
                                                        onClick={() => setStep(1)}
                                                        style={{ fontSize: "1.25rem", lineHeight: "1.5rem", verticalAlign: "top", cursor: "pointer" }}
                                                    ></em>
                                                    {" " + familyAccount.firstName + " " + familyAccount.lastName}
                                                </div>
                                            </div>
                                            <div role="gridcell" className="col-xs-6 col-sm-4 col-no-gutter">
                                                <div className="data-value">{getPlanValue()}</div>
                                            </div>
                                            <div role="gridcell" className="col-xs-6 col-sm-4 col-no-gutter text-align-right">
                                                <div className="data-value">{getRecurCost()}</div>
                                            </div>
                                        </div>

                                        <div className="margin-top-l"></div>
                                    </div>
                                </div>

                                <div className="box-content data-grid has-lines">
                                    <div className="margin-top-l"></div>
                                    <p>
                                        Your credit score is calculated based on the <strong> VantageScore&reg; 3.0 model</strong>. Lenders and insurers may use different scores to evaluate your eligibility.
                                    </p>
                                </div>

                                <div className={`form-row inline row ${errors["isTermsNadConditionCHecked"] && "status-error"}`}>
                                    <div className="form-label col-xs-12 col-sm-12 col-no-gutter">
                                        <div className="form-row no-margin">
                                            <div className="form-input">
                                                <label className="form-checkbox-label" htmlFor="isTermsNadConditionCHecked">
                                                    <input
                                                        type="checkbox"
                                                        id="isTermsNadConditionCHecked"
                                                        name="isTermsNadConditionCHecked"
                                                        ref={register({ required: true })}
                                                        onChange={() => setIsTermsNadConditionCHecked(!isTermsNadConditionCHecked)}
                                                        checked={isTermsNadConditionCHecked}
                                                    />
                                                    <span className="form-checkbox-label-text">
                                                        I agree to the{" "}
                                                        <span className="default_link">
                                                            <a href="https://www.sontiq.com/terms-of-use/" target="_blank" className="default_link">
                                                                {termsOfUseLegalDocumentLabel}
                                                            </a>
                                                        </span>
                                                        .
                                                    </span>
                                                </label>
                                                {errors["isTermsNadConditionCHecked"] && errors["isTermsNadConditionCHecked"].type === "required" && (
                                                    <span className="form-error">You must accept the Terms and Conditions to continue.</span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <p>
                                    I understand that I will be billed ${getCost()} each {getBillingCycle()} until this membership is cancelled. If I cancel, my
                                    membership will end immediately and I will not be billed further. All payments are non-refundable.
                                </p>
                                <p>By clicking continue, your credit card will be billed today and will recur {getBillingCycle()}ly.</p>
                            </React.Fragment>
                        )}
                    </div>

                    <div className="dialog-footer">
                        <div className="row between-xs">
                            <div className="col-xs col-no-gutter flex-grow-null">
                                <button type="button" className="btn-default btn-link btn-no-padding btn-no-border" onClick={() => closeDialog()}>
                                    <span className="btn-text">Cancel</span>
                                </button>
                            </div>
                            <div className="col-xs col-no-gutter flex-grow-null">
                                <button type="submit" className="btn-default btn-primary">
                                    <span className="btn-text">Continue</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </React.Fragment>
        );
    };

    return (
        <React.Fragment>
            {!isLoading ? (
                <>
                    <div className="dialog-header">
                        <div className="dialog-icon">
                            <em className="las la-user-plus"></em>
                        </div>
                        <h1>Add Family Member</h1>
                    </div>
                    {getStepView()}
                </>
            ) : (
                <div className="box loading"></div>
            )}

            {showBillingInfoDialog && (
                <DialogComponent
                    dialogId="protection-plan-billing-information-dialog"
                    title="Billing Information"
                    datalayerEvent="Protection Plan - Close billing info"
                    closeDialog={() => {
                        handleBillingCloseDialog("close");
                    }}
                >
                    <IDFProtectionPlanBillingInfo
                        dialogId="protection-plan-billing-information-dialog"
                        closeDialog={() => {
                            handleBillingCloseDialog("close");
                        }}
                        creditCard={creditCard}
                    />
                </DialogComponent>
            )}
        </React.Fragment>
    );
};

export default IDFFamilyServiceDialog;
